import { toast, Flip } from "react-toastify";
import { deleteEmployee, addEmployee } from "../services/userService";
import { UserContent, UserEmployeeData } from "../EditUser/component/types";

export const Update = (
  customerdata: any,
  setloading: Function,
  onSuccess?: Function // Add callback for success
) => {
  setloading(true);
  return addEmployee(customerdata) // Return the promise
    .then(() => {
      // notifySuccess("User updated successfully");
      setloading(false);
      if (onSuccess) {
        onSuccess(); // Call success callback
      }
    })
    .catch((error: any) => {
      console.error("Error during user upload:", error);
      setloading(false);
      const message = error.response?.data?.message;
      if (message === "Email Already Exists") {
        toast.error("Email already exists");
      } else if (message === "Username Already Exist") {
        toast.error("Username already exists");
      } else {
        toast.error("An error occurred");
      }
      throw error; // Re-throw the error to handle in component
    });
};

export const Delete = (
  id: string | number,
  setTempId: Function,
  setEmployeedata: Function,
  setFilteredData: Function
) => {
  deleteEmployee(id)
    .then(() => {
      setTempId("");
      // notifySuccess("User deleted successfully");
      setEmployeedata((prevData: any[]) => prevData.filter((item) => item._id.$oid !== id));
      setFilteredData((prevData: any[]) => prevData.filter((item) => item._id.$oid !== id));
    })
    .catch((error) => {
      console.error("Error deleting user:", error);
      toast.error("Failed to delete user", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Flip,
      });
    });
};

export const filters = (
  value: boolean,
  api: any,
  setfear: Function,
  setEmployeedata: Function,
  setFilteredData: Function
) => {
  if (value === true) {
    api
      .get(`/pos/add_employee/DeletedUsers`)
      .then((res: any) => {
        const emergency: UserContent[] = res.data.result;
        setfear(emergency);
        console.log("delete", res);
        if (res.data.message === "No deleted users found") {
          const err = res.data.message;
          toast(err);
        }
        const user: UserEmployeeData[] = res.data.result;
        if (user) {
          setEmployeedata(user);
          setFilteredData(user);
        }
      })
      .catch((error: any) => {
        const err = error.response?.data?.message || "An unknown error occurred";
        if (err === "Email Already Exists") {
          toast.error("Email Already Exists. Please try a different email.");
        } else {
          toast.error(err);
        }
      });
  } else {
    api.get(`/pos/get_user`).then((res: any) => {
      const user: UserEmployeeData[] = res.data.result.filter((data: { user_name: any }) => data.user_name !== undefined);
      setEmployeedata(user);
      setFilteredData(user);
    });
  }
};